<template lang="pug">
  div
    .d-flex.justify-space-between.align-center.mb-2
      // Edit Mode
      .d-flex.align-center.gap-1(v-if="isEditMode")
        // Amount input field
        yz-text-field(v-model="amount" type="number" placeholder="0" size="md" style="max-width: 100px" :prefix="$currency.symbol" min="0" :rules="rejectedAmountRules" autofocus)

        // Tick button (show when has value and is valid)
        yz-btn(v-if="hasValue && isValid" icon="$yzi-check" icon-only size="sm" icon-color="yz-success-500" @click="onExitEditMode")
        // Close button
        yz-btn(icon="mdi-close" icon-only size="sm" color="yz-neutral-500" @click="onRemoveValueAndExit")
      // Read Mode
      .d-flex.align-center.gap-1(v-else)
        .yz-medium-body-sm.text-neutral-700.no-wrap(:class="[hasValue || readonly ? '' : 'underline cursor-pointer deduction-hover']" @click="onEnterEditMode") {{ $t('panel.rejected_amount_label') }}
        // Close button (hidden in readonly mode)
        yz-btn(v-if="hasValue && !readonly" icon="mdi-close" icon-only size="sm" color="yz-neutral-500" @click="onRemoveValue")

      .d-flex.align-center.gap-2
        yz-btn(v-if="hasValue && !isEditMode" :label="balanceAssigned || readonly ? $t('panel.assigned') : $t('panel.assign_balance')" :append-icon="balanceAssigned || readonly ? '' :  '$yzi-switch-horizontal-duotone-01'" size="sm" icon-color="yz-neutral-500" outlined, :disabled="balanceAssigned || readonly", @click="onAssignBalance")
        .yz-medium-body-sm.text-neutral-700 {{ displayAmount | displayPrice($currency) }}

</template>

<script>
import { validateDecimalPlaces } from '@/utils'

export default {
  props: {
    value: {
      type: Number,
      default: null
    },
    balanceAssigned: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      amount: null,
      isEditMode: false
    }
  },
  computed: {
    displayAmount() {
      return this.amount !== null ? Math.round(this.amount * this.$currency.multiplier) : 0
    },
    hasValue() {
      return this.amount !== null && this.displayAmount > 0
    },
    rejectedAmountRules() {
      return [
        v => v === null || v === '' || v >= 0 || this.$t('rejected_amount_cannot_be_negative'),
        v => validateDecimalPlaces(v, this.$currency)
      ]
    },
    isValid() {
      if (this.amount === null || this.amount === '') return true
      return this.rejectedAmountRules.every(rule => rule(this.amount) === true)
    }
  },
  mounted() {
    this.amount = this.value ? this.value / this.$currency.multiplier : null
  },
  watch: {
    value(newValue) {
      this.amount = newValue ? newValue / this.$currency.multiplier : null
      this.$emit('updated')
    }
  },
  methods: {
    onEnterEditMode() {
      if (!this.hasValue && !this.readonly) {
        this.isEditMode = true
      }
    },
    onExitEditMode() {
      if (this.amount === null || this.amount === '' || this.amount <= 0) {
        this.amount = null
        this.$emit('input', null)
      } else {
        const centValue = Math.round(this.amount * this.$currency.multiplier)
        this.$emit('input', centValue)
      }
      this.isEditMode = false
    },
    onRemoveValue() {
      this.amount = null
      this.$emit('input', null)
    },
    onAssignBalance() {
      this.$emit('assign-balance')
    },
    onRemoveValueAndExit() {
      this.onRemoveValue()
      this.isEditMode = false
    }
  }
}
</script>

<style lang="scss" scoped>
.deduction-hover {
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--yz-neutral-300);
    border-radius: 4px;
  }
}
</style>